/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.25.1
 */

export const replaceDecimalDot = (amount?: number, replaceValue = ',') => {
    if (amount === null || amount === undefined) return undefined;
    return amount.toString().replace('.', replaceValue);
};
